<template>

  <v-dialog v-model="dialog" scrollable max-width="500px" persistent>
    <v-card>
      <v-card color="blue">
        <v-card-title flat class='white--text title'>{{'TITLE_PASSWORD_FORGOT' | translate}}</v-card-title>
      </v-card>

      <v-card-text class="my-5">
        {{'TEXT_DIALOG_SENDMAIL' | translate}}
      </v-card-text>

      <v-btn to="/" color="#004884" small dark round outline class="radiusBtn text-none mb-5">{{'BUTT_BACK_LOGIN' | translate}}</v-btn>

    </v-card>
  </v-dialog>
</template>

<script>
//  import Vue from 'vue'
import ContactForm_Support from './../../widgets/ContactForm_Support'

export default {
  name: 'DialogSndEMail',
  components: {ContactForm_Support},
  methods: {
    /**
     * newName, title, type
     * @param cardConfig
     */
    open: function () {
      this.dialog = true
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted () {
    //
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogSendEMail.vue